// @flow
import type { Dispatch } from 'redux';
import { isNaN, partition } from 'lodash';

import {
  ACCEPT_FRIEND_REQUEST,
  CREATE_FRIEND_REQUEST,
  REMOVE_FRIEND_REQUEST,
  FRIEND_REQUESTS
} from '../constants/apiTypes';
import { API_CALL } from '../constants/actionTypes';
import * as friendRequestsApi from '../api/friendRequests';

export function fetchFriendRequests() {
  return {
    type: API_CALL,
    api: FRIEND_REQUESTS,
    request: friendRequestsApi.getFriendRequests().then(res => ({ friendRequests: res.data }))
  };
}

export function createFriendRequests(requesteeIds: Array<string | number>, groupId?: number) {
  const [emailUsers, systemUsers] = partition(requesteeIds, isNaN);
  const data = {
    // ids (existing users) are numbers
    recipients: systemUsers,
    // emails are strings
    email_recipients: emailUsers,
    group_id: groupId
  };
  return {
    type: API_CALL,
    api: CREATE_FRIEND_REQUEST,
    requestIds: systemUsers,
    request: friendRequestsApi.createFriendRequests(data).then(results => ({
      friendRequests: results.data,
      groupId
    }))
  };
}

export function createFriendRequest(userId: number, groupId?: number) {
  return createFriendRequests([userId], groupId);
}

// cancel a friend request
export function removeFriendRequest(id: number) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const request: FriendRequest = getState().friendRequests.friendRequests[id];

    dispatch({
      type: API_CALL,
      api: REMOVE_FRIEND_REQUEST,
      request: friendRequestsApi.removeFriendRequest(request.requestId),
      id
    });
  };
}

// ignore a friend request
export function rejectFriendRequest(id: number) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const request: FriendRequest = getState().friendRequests.friendRequests[id];
    if (!request.token) {
      throw new Error('cannot reject a friend request without a token');
    }
    dispatch({
      type: API_CALL,
      api: REMOVE_FRIEND_REQUEST,
      request: friendRequestsApi.rejectFriendRequest(request.id, request.token).then(() => ({
        id: request.id
      })),
      id
    });
  };
}

// friend a user
export function acceptFriendRequest(id: number) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const request = getState().friendRequests.friendRequests[id];
    if (!request.token) {
      throw new Error('cannot accept a friend request without a token');
    }
    dispatch({
      type: API_CALL,
      api: ACCEPT_FRIEND_REQUEST,
      request: friendRequestsApi.acceptFriendRequest(request.id, request.token).then(res => ({
        friend: res.data,
        id
      })),
      id
    });
  };
}
